// 🚀 SOLUTION RAPIDE : Modifier ShareSection.tsx

import React from 'react';
import { Users, Copy, Check } from 'lucide-react';

interface ShareSectionProps {
    referralLink: string;
    copySuccess: boolean;
    onCopyLink: () => void;
    onShareWhatsApp: () => void;
    onShareSocial: (platform: 'telegram' | 'twitter' | 'facebook' | 'linkedin') => void;
    referralCode?: string; // ← AJOUTER le code de parrainage
}

const ShareSection: React.FC<ShareSectionProps> = ({
                                                       referralLink,
                                                       copySuccess,
                                                       onCopyLink,
                                                       onShareWhatsApp,
                                                       onShareSocial,
                                                       referralCode
                                                   }) => {
    // 🎯 NOUVELLE FONCTION pour Facebook avec message personnalisé
    const handleFacebookShare = () => {
        // Message pré-rédigé que l'utilisateur pourra modifier
        const preMessage = `🎉 Rejoignez l'Union Démocratique des Bâtisseurs !

Je vous invite à rejoindre notre mouvement politique pour transformer le Gabon.

👉 ${referralLink}

#UDB #UnionDemocratiqueDesBatisseurs #Gabon`;

        // Copier le message dans le presse-papiers
        navigator.clipboard.writeText(preMessage).then(() => {
            // Ouvrir Facebook
            const facebookUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(referralLink)}`;
            window.open(facebookUrl, '_blank');

            // Notification à l'utilisateur
            alert('Message copié ! 📋\n\nCollez-le dans votre publication Facebook qui va s\'ouvrir.');
        }).catch(() => {
            // Si le clipboard ne marche pas, ouvrir directement Facebook
            const facebookUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(referralLink)}`;
            window.open(facebookUrl, '_blank');
        });
    };

    return (
        <div className="bg-gradient-to-r from-yellow-100 to-green-100 p-8 rounded-lg border border-yellow-200">
            <div className="flex items-center space-x-3 mb-6">
                <Users className="w-6 h-6 text-green-600" />
                <h3 className="text-xl font-semibold text-gray-900">Invitez vos proches ! 🚀</h3>
            </div>

            <p className="text-gray-600 mb-6">
                Partagez votre lien de parrainage et aidez l'Union Démocratique des Bâtisseurs à grandir.
                Chaque nouveau membre vous fait gagner des badges exclusifs !
            </p>

            {/* Lien de parrainage */}
            <div className="bg-white p-4 rounded-lg border mb-6">
                <div className="flex items-center space-x-2">
                    <code className="flex-1 text-sm text-gray-700 break-all">
                        {referralLink}
                    </code>
                    <button
                        onClick={onCopyLink}
                        className={`px-4 py-2 rounded-lg text-sm font-semibold transition-all ${
                            copySuccess
                                ? 'bg-green-600 text-white'
                                : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
                        }`}
                    >
                        {copySuccess ? <Check className="w-4 h-4" /> : <Copy className="w-4 h-4" />}
                    </button>
                </div>
            </div>

            {/* Boutons de partage */}
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                <button
                    onClick={onShareWhatsApp}
                    className="bg-green-500 text-white py-3 px-4 rounded-lg font-semibold hover:bg-green-600 transition-colors text-sm"
                >
                    WhatsApp
                </button>
                <button
                    onClick={() => onShareSocial('telegram')}
                    className="bg-blue-500 text-white py-3 px-4 rounded-lg font-semibold hover:bg-blue-600 transition-colors text-sm"
                >
                    Telegram
                </button>
                <button
                    onClick={() => onShareSocial('twitter')}
                    className="bg-blue-400 text-white py-3 px-4 rounded-lg font-semibold hover:bg-blue-500 transition-colors text-sm"
                >
                    Twitter
                </button>
                {/* 🎯 FACEBOOK AVEC GESTION SPÉCIALE */}
                <button
                    onClick={handleFacebookShare}
                    className="bg-blue-600 text-white py-3 px-4 rounded-lg font-semibold hover:bg-blue-700 transition-colors text-sm relative"
                >
                    Facebook
                    <span className="absolute -top-1 -right-1 bg-yellow-400 text-blue-800 text-xs rounded-full w-4 h-4 flex items-center justify-center font-bold">
                        ✨
                    </span>
                </button>
            </div>

            {/* 📝 MESSAGE D'AIDE POUR FACEBOOK */}
            <div className="mt-4 p-4 bg-blue-50 border border-blue-200 rounded-lg">
                <div className="flex items-start space-x-2">
                    <div className="text-blue-600 text-lg">📱</div>
                    <div>
                        <h4 className="font-semibold text-blue-800 mb-1">Partage Facebook optimisé</h4>
                        <p className="text-sm text-blue-700">
                            En cliquant sur Facebook, votre message personnalisé sera copié automatiquement.
                            Collez-le simplement dans votre publication !
                        </p>
                        <div className="mt-2 p-2 bg-white rounded border text-xs text-gray-600">
                            <strong>Votre code :</strong> <code className="bg-yellow-100 px-1 rounded">{referralCode}</code>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ShareSection;
